import { useEffect } from 'react';

import { useGetCustomRatesListQuery } from '../api';
import { useAppDispatch, useTypedSelector } from '../store';
import { setConfigs, setError, setLoading } from '../store/configSlice';

export const useConfigs = () => {
	const dispatch = useAppDispatch();
	const { configs, hasConfigs, isLoading, error } = useTypedSelector(
		(state) => state.config,
	);

	const {
		data: configsResponse,
		isLoading: apiLoading,
		error: apiError,
		refetch,
	} = useGetCustomRatesListQuery({
		page: 1,
		page_size: 10,
	});

	useEffect(() => {
		if (configsResponse?.data) {
			dispatch(setConfigs(configsResponse.data));
		}
	}, [configsResponse?.data, dispatch]);

	useEffect(() => {
		dispatch(setLoading(apiLoading));
	}, [apiLoading, dispatch]);

	useEffect(() => {
		if (apiError) {
			dispatch(setError(apiError?.message || 'Failed to fetch configs'));
		} else {
			dispatch(setError(null));
		}
	}, [apiError, dispatch]);

	const refreshConfigs = () => {
		refetch();
	};

	const checkHasConfigs = () => {
		return hasConfigs;
	};

	return {
		configs,
		hasConfigs,
		isLoading,
		error,
		refreshConfigs,
		checkHasConfigs,
	};
};
